import type { SxProps, Theme } from '@mui/material/styles';

export const studioFooterStyles = {
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    px: 2,
    py: 1,
    borderTop: 1,
    borderColor: 'divider',
    bgcolor: 'background.paper',
  } as SxProps<Theme>,

  rightSide: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  } as SxProps<Theme>,

  envPill: {
    display: 'inline-flex',
    alignItems: 'center',
    px: 1,
    py: 0.25,
    borderRadius: '999px',
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: 0.4,
    textTransform: 'uppercase',
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
  } as SxProps<Theme>,

  mismatchPill: {
    display: 'inline-flex',
    alignItems: 'center',
    px: 1,
    py: 0.25,
    borderRadius: '999px',
    bgcolor: 'warning.main',
    color: 'common.white',
    fontSize: 10,
    fontWeight: 900,
    letterSpacing: 0.2,
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
    boxShadow: 1,
    border: '1px solid',
    borderColor: 'warning.dark',
    gap: 0.5,
  } as SxProps<Theme>,

  mismatchIcon: {
    fontSize: 14,
  } as SxProps<Theme>,
};
